/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = 0;
var header = document.getElementById("masthead");
var body = document.getElementsByTagName("body")[0];
window.onscroll = function () {
  var currentScrollPos = window.scrollY;
  if (currentScrollPos < 100) {
    header.classList.remove("top");
    body.classList.remove("scroll");
  } else {
    header.classList.add("top");
    body.classList.add("scroll");
  }
  prevScrollpos = currentScrollPos;
};
